import { defineComponent, computed } from '@vue/composition-api';
import __vue_component__ from '../SdsIcon/SdsIcon.vue.js';

var script = defineComponent({
    name: 'SdsBadge',
    props: {
        styling: {
            type: String,
            required: true,
        },
        hasIcon: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    setup: function (props) {
        var iconName = computed(function () {
            switch (props.styling) {
                case 'success':
                    return 'status-checkmark-alt-filled';
                case 'warning':
                    return 'status-danger-filled';
                case 'danger':
                    return 'status-warning-filled';
                case 'info':
                    return 'status-info-filled';
                case 'neutral':
                    return 'toggle-notification-filled';
            }
        });
        return {
            iconName: iconName,
        };
    },
    components: {
        SdsIcon: __vue_component__,
    },
});

export default script;
